module.exports = __webpack_public_path__ + "img/m.2d272644.jpg";